module.exports = __webpack_public_path__ + "static/media/DMSans-Bold.758620ee.svg";